import { render } from "./PCUltimosPalesGenerados.vue?vue&type=template&id=04636349&scoped=true"
import script from "./PCUltimosPalesGenerados.vue?vue&type=script&lang=js"
export * from "./PCUltimosPalesGenerados.vue?vue&type=script&lang=js"

import "./PCUltimosPalesGenerados.vue?vue&type=style&index=0&id=04636349&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04636349"]])

export default __exports__